<script setup lang="ts">
import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { logService } from '@nsftx/seven-client-retail-utils'
import { useSpinnerStore } from '@nsftx/seven-nxg-retail-vue-sdk'
import { NXGRetailLoadingOverlay, NXGRetailNotifications } from '@nsftx/seven-nxg-retail-vue-sdk/ui'
import { getDeviceAccessToken } from '@nsftx/seven-client-retail-vue-dm'
import SBOAppLayout from './ui/layouts/SBOAppLayout.vue'
import { useAppBootstrap } from './composables/useAppBootstrap/useAppBootstrap'

const LOG_PREFIX = '[App]'

const { isSpinnerOpened } = storeToRefs(useSpinnerStore())
const { startApp, handleDeviceAccessTokenReceived } = useAppBootstrap()

const accessToken = getDeviceAccessToken()

watch(accessToken, (token) => {
  logService.info(`${LOG_PREFIX} Access token updated`, {
    code: 'SBO_ACCESS_TOKEN_UPDATED',
    details: {
      hasToken: !!token
    }
  })
  if (token) handleDeviceAccessTokenReceived(token)
})

startApp()
</script>

<template>
  <div class="app-wrapper">
    <SBOAppLayout />
    <NXGRetailNotifications position="topMiddle" />
    <NXGRetailLoadingOverlay :visible="isSpinnerOpened" />
  </div>
</template>
<style scoped>
.app-wrapper {
  background: var(--nxgds-mapped-color-surface-neutral-600, #2c2e30);
  height: 100vh;
  width: 100vw;
}
</style>
